module.exports = __webpack_public_path__ + "static/media/stijn-bessem-clients-kpito.c8f8e1a1.svg";